import { render, staticRenderFns } from "./SubscribePage.vue?vue&type=template&id=54fe230a&lang=pug&"
import script from "./SubscribePage.vue?vue&type=script&lang=js&"
export * from "./SubscribePage.vue?vue&type=script&lang=js&"
import style0 from "./SubscribePage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports